module.exports = __webpack_public_path__ + "static/img/ADD.7fecb13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/ADD.png
// module id = HEx7
// module chunks = 0